// removed by extract-text-webpack-plugin
module.exports = {"paper":"_3JvVVSjHit14VdQN82ovwQ","select":"_2KeDLzvl4iN9brA7j6UwOR","filename":"_2sE-zPJpPjQxDVqZj04CSg","fileIcon":"_2aFVYacN2_eF3SRtooToWx","delete":"_2kP2nJYXN-wMgFYRnFxVbD"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/PaperForm/PaperForm.css
// module id = 730
// module chunks = 3